/* @flow */

import * as React from 'react';

import {IconButton} from '../../../button';

import type {EventType} from '../../types';

import type {ToolbarOption} from './timeline-entry-toolbar';

export function getNounForEntryType(entryType: EventType): string {
    switch (entryType) {
        // Activities and meetings
        case 'Activity':
        case 'ZoomMeeting':
        case 'GoogleMeet':
        case 'MicrosoftTeams':
        case 'TeamsMeeting':
        case 'Aircall':
        case 'CallRail':
        case 'Dialpad':
        case 'RingCentral':
        case 'CallTrackerFX':
            return 'activity';

        // Notes and comments
        case 'Note':
            return 'note';
        case 'Comment':
            return 'comment';

        // Emails
        case 'Email':
        case 'EmailQueued':
        case 'AutomatedEmail':
        case 'AutomatedReply':
        case 'NutshellMarketingEmail':
        case 'FailedEmail':
            return 'email';

        // There are a lot more types that are not enumerated here, but they can't be deleted
        default:
            return 'entry';
    }
}

export function renderOptionForToolbar(option: ToolbarOption): React.Node {
    if (option.icon) {
        return (
            <IconButton
                key={option.id}
                icon={option.icon}
                onClick={option.onClick}
                tooltipText={option.tooltipText}
                isDisabled={option.isDisabled}
            />
        );
    }

    // The null case shouldn't ever happen, but flow is confused
    return option.component ? (
        <React.Fragment key={option.id}>{option.component}</React.Fragment>
    ) : null;
}
